module.exports = __webpack_public_path__ + "static/media/logo-white.40d4ef82.png";